export default __webpack_public_path__ + "static/activate-fddd766a896163e539f64ba7604ac956.gif";